import { IStandardAPIResponse, IMergedCustomers } from "../../vm";
import { httpClient, handleErrorResp, httpFileUpload } from "../UtilService";

export async function getMergedCustomers(searchObj: {
    offset?: number,
    limit?: number,
    search?: string,
    mergedCustomerId?: string
}): Promise<IStandardAPIResponse<{ mergedCustomers: Array<IMergedCustomers>, count: number }>> {
  try {
    let res = await httpClient<{ mergedCustomers: Array<IMergedCustomers>, count: number }>(
      `merged-customers`,
      "GET",
      searchObj
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function addMergedCustomer(
  data: IMergedCustomers
): Promise<IStandardAPIResponse<IMergedCustomers>> {
  try {
    let res = await httpClient<IMergedCustomers>(
      `merged-customers`,
      "PUT",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateMergedCustomer(
  data: IMergedCustomers
): Promise<IStandardAPIResponse<IMergedCustomers>> {
  try {
    let res = await httpClient<IMergedCustomers>(
      `merged-customers/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function deleteMergedCustomer(id: string): Promise<IStandardAPIResponse<IMergedCustomers>> {
  try {
    let res = await httpClient<IMergedCustomers>(
      `merged-customers/${id}`,
      "DELETE"
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
